package org.hs_soft.runmynesto.pages.home.sub_page.template

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.pages.components.LoadingProgress
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.GridTemplateBar
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.TemplateDialogs
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.TemplateContent
import org.hs_soft.runmynesto.pages.home.sub_page.template.mvi.TemplateEvent
import org.hs_soft.runmynesto.pages.home.sub_page.template.mvi.TemplateState
import org.hs_soft.runmynesto.pages.home.sub_page.template.mvi.TemplateViewModel

@Composable
fun Template(
    windowSizeMode: WindowSizeModeEnum,
    viewModel: TemplateViewModel,
)
{
    val state by viewModel.state.collectAsState()
    LaunchedEffect(viewModel){
        viewModel.onEvent(TemplateEvent.GetTemplateCategoryList)
        viewModel.onEvent(TemplateEvent.GetCheckoutData)
        viewModel.onEvent(TemplateEvent.GetPriceLevels)
    }

    Column(
        modifier = Modifier
            .scrollBehavior(ScrollBehavior.Smooth)
            .fillMaxSize()
    ) {

        Row(
            modifier = Modifier
                .fillMaxSize()
                .margin(
                    top = Dimen.smallPadding,
                ),
            horizontalArrangement = Arrangement.Center
        )
        {

            if(state.firstPageActive){
                GridTemplateBar(
                    windowSizeMode =windowSizeMode,
                    selectedItem =state.selectedCategory,
                    infoList =state.templateCategoryList,
                    loading=state.loadingProgress,//templateCategoryListLoading,
                    showFilterComponent = state.showTemplateItemsFilterComponentDialog,
                    selectedFilterOption = state.selectedTemplateFilterItemsType,
                    onTitleSortClick = {

                    },
                    onRefreshUserList = {
                        viewModel.onEvent(TemplateEvent.RefreshTemplateCategoriesList)
                    },
                    onCategoryClick = { id->
                        viewModel.onEvent(TemplateEvent.OnTemplateCategoryClick(
                                id=id,
                                switchToSecondPage = {
                                    if(windowSizeMode== WindowSizeModeEnum.PHONE)
                                        viewModel.onEvent(TemplateEvent.OnChangePageClick)
                                }
                            )
                        )
                    },
                    updateListAfterDragAndDrop ={ newList, idList, positionList->
                        viewModel.onEvent(TemplateEvent.
                            UpdateTemplateCategoryListAfterDragDrop(
                                newList = newList,
                                idList=idList,
                                positionList=positionList
                            ))
                    },
                    onAddRecord = {
                        viewModel.onEvent(TemplateEvent.OnAddRecordIconClick)
                    },
                    titleDescending = false,
                    showTitleSortIcon =false,
                    onSwipeRight = {
                        viewModel.onEvent(TemplateEvent.OnChangePageClick)
                    },
                    onFilterComponentClick = {
                        viewModel.onEvent(
                            TemplateEvent.SetFilterTemplateItemsComponentStatus(
                                !state.showTemplateItemsFilterComponentDialog
                            )
                        )
                    },
                    onCloseFilterClick = {
                        viewModel.onEvent(TemplateEvent.SetFilterTemplateItemsComponentStatus(false))
                    },
                    selectFilterType = {
                        viewModel.onEvent(TemplateEvent.SelectTemplateFilterType(it))
                    },
                    submitFilterItems = {
                        viewModel.onEvent(TemplateEvent.SubmitTemplateFilterItems)
                    },

                )

                if(windowSizeMode!= WindowSizeModeEnum.PHONE){
                    content(
                        state=state,
                        event=viewModel::onEvent,
                        windowSizeMode=windowSizeMode,
                        showImgUrl={key->
                            viewModel.showImgURL(key=key)
                        },
                    )
                }
            }
            else{
                content(
                    state=state,
                    event=viewModel::onEvent,
                    windowSizeMode=windowSizeMode,
                    showImgUrl = { key->
                        viewModel.showImgURL(key=key)
                    }
                )
            }
        }


    }


    LoadingProgress(
        visibility = state.loadingProgress,
    )


    TemplateDialogs(
        state=state,
        windowSizeMode=windowSizeMode,
        event=viewModel::onEvent
    )



}



@Composable
private fun content(
    state: TemplateState,
    event: (TemplateEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
    showImgUrl:suspend (String)->String,
) {

    TemplateContent(
        modifier = Modifier,
        currencyType=state.currencyType,
        selectedTab =state.selectedTab,
        selectedDate=state.selectedDate,
        articleRowsCount=state.articleRowsCount,
        articleColumnsCount=state.articleColumnsCount,
        countryId = state.companyProfileId,
        selectedArticleSortingId = state.selectedArticleSortId,
        selectedWaiterDeviceType=state.selectedWaiterDeviceType,
        selectedWaiterLayoutType=state.selectedWaiterLayoutType,
        selectedCategory = state.selectedCategory,
        articleList = state.articleList?: listOf(),
        windowSizeMode = windowSizeMode,
        selectedDays = state.selectedDays,
        showTitleSortIcon = state.showArticleTitleSortIcon,
        imgUrl = state.templateItemImg,
        checkOutData = state.cashList,
        isCheckoutExpandAll =  state.checkOutExpandAll,
        checkoutSearchValue =state.checkOutSearchValue ,
        priceLevelList = state.priceLevels?: listOf(),
        selectedPriceLevelIndex = state.selectedPriceLevelIndex,
        selectedColor = state.selectedPalletColor,
        openColorPanel = {
             event(TemplateEvent.SetColorPalletStatus(true))
        },
        onRefreshClick = {
            event(TemplateEvent.RefreshArticleList)
        },
        onSearchValueChange = {
            event(TemplateEvent.OnSearchArticleInputChange(it))
        },
        onTitleSortClick = {
//            event(TemplateEvent.OnArticleTitleSortClick)
        },
        updateArticleRowsCount = {rows,columns->
             event(TemplateEvent.UpdateArticleRowsCount(rows,columns))
        },
        onChangeActivity = { id, isActive ->
            event(
                TemplateEvent.OnUpdateTemplateCategoryInfo(
                    id = id,
                    dataTitle = ApiUtils.Field.isActive,
                    dataValue = isActive
                )
            )
        },
        onChangeReceiptName = { id, value ->
            event(
                TemplateEvent.OnUpdateTemplateCategoryInfo(
                    id = id,
                    dataTitle = ApiUtils.Field.name,
                    dataValue = value
                )
            )
        },
        onTabClick = {
            event(TemplateEvent.OnTabClick(it))
        },
        onCheckoutSearch = {
            event(TemplateEvent.OnSearchCheckoutItems(it))
        },
        updateTemplateCheckout = {
            event(TemplateEvent.UpdateCheckout(it))
        },
        getPriceLevels = {
            event(TemplateEvent.GetPriceLevels)
        },
        updatePriceLevel = {
            event(TemplateEvent.UpdatePriceLevel(it))
        },
        updateSurcharge = {fieldTitle,newList->
            event(TemplateEvent.UpdateSurcharge(
                title=fieldTitle,
                values=newList
            ))
        },
        setCalendarStatus = {
            event(TemplateEvent.SetCalendarStatus(it))
        },
        onChangeDayCheckStatus = {
            event(TemplateEvent.OnUpdateTemplateCategoryInfo(
                id = state.selectedCategory?.id?:"",
                dataTitle = ApiUtils.Field.weekDays,
                dataValue = it
            ))
        },
        showImgAIGeneratorDialog = {
            event(TemplateEvent.SetGenerateAIImgDialogStatus(true))
        },
        updateProductListAfterDragAndDrop = { newList, idList, positionList,productIdList ->
            event(TemplateEvent.
                UpdateCategoryBasedProductListAfterDragDrop(
                    newList = newList,
                    idList=idList,
                    positionList=positionList,
                    productIdList=productIdList,
                )
            )
        },
        onAddProductIconClick = {
            event(TemplateEvent.OnAddToArticleIconClick)
        },
        onDeviceTypeClick = {
            event(TemplateEvent.ChooseWaiterDeviceType(it))
        },
        onShowLayoutTypeClick = {
            event(TemplateEvent.ChooseWaiterLayoutType(it))
        },
        showImgUrl = {key:String->
            showImgUrl(key)
        },
        deleteGridProduct = {position:Int->
            event(TemplateEvent.SetGridProduct(
                position=position,
            ))
        },
        setGridProduct = {productId:String,position:Int->
            event(
                TemplateEvent.SetGridProduct(
                    position=position,
                    productId = productId,
                )
            )
        },
        selectArticleSorting = {
            event(
                TemplateEvent.OnUpdateTemplateCategoryInfo(
                    id = state.selectedCategory?.id?:"",
                    dataTitle = ApiUtils.Field.sortId,
                    dataValue = it.sortId
                )
            )
        }




    )
}

